import { OpportunityFormTypeStep } from './components/opportunity-form/type-step/opportunity-form-type-step'
import type { OpportunityFormTypeStepProps } from './components/opportunity-form/type-step/opportunity-form-type-step.types'
import { OpportunityFormNameField } from './components/opportunity-form/name-field/opportunity-form-name-field'
import type { OpportunityFormNameFieldProps } from './components/opportunity-form/name-field/opportunity-form-name-field.types'
import { OpportunityFormDescriptionField } from './components/opportunity-form/description-field/description-field'
import type { OpportunityFormDescriptionFieldProps } from './components/opportunity-form/description-field/description-field.types'
import { OpportunityFormSingleOrSeriesStep } from './components/opportunity-form/single-or-series-step/opportunity-form-single-or-series-step'
import type { OpportunityFormSingleOrSeriesStepProps } from './components/opportunity-form/single-or-series-step/opportunity-form-single-or-series-step.types'
import { OpportunityFormDateFields } from './components/opportunity-form/date-fields/opportunity-form-date-fields'
import type { OpportunityFormDateFieldsProps } from './components/opportunity-form/date-fields/opportunity-form-date-fields.types'
import { OpportunityFormTimeTrackingCheckbox } from './components/opportunity-form/time-tracking-checkbox/opportunity-form-time-tracking-checkbox'
import type { OpportunityFormTimeTrackingCheckboxProps } from './components/opportunity-form/time-tracking-checkbox/opportunity-form-time-tracking-checkbox.types'
import { OpportunityFormLocationSection } from './components/opportunity-form/location-section/opportunity-form-location-section'
import type { OpportunityFormLocationSectionProps } from './components/opportunity-form/location-section/opportunity-form-location-section.types'
import { OpportunityFormMaxAttendeesField } from './components/opportunity-form/max-attendees-field/opportunity-form-max-attendees-field'
import type { OpportunityFormMaxAttendeesFieldProps } from './components/opportunity-form/max-attendees-field/opportunity-form-max-attendees-field.types'
import { OpportunityFormNotificationsEnabledCheckbox } from './components/opportunity-form/notifications-enabled-checkbox/opportunity-form-notifications-enabled-checkbox'
import type { OpportunityFormNotificationsEnabledCheckboxProps } from './components/opportunity-form/notifications-enabled-checkbox/opportunity-form-notifications-enabled-checkbox.types'
import { OpportunityFormSkillsAndActivitiesSection } from './components/opportunity-form/skills-and-activities-section/opportunity-form-skills-and-activities-section'
import type { OpportunityFormSkillsAndActivitiesSectionProps } from './components/opportunity-form/skills-and-activities-section/opportunity-form-skills-and-activities-section.types'
import { OpportunityFormWaitlistEnabledCheckbox } from './components/opportunity-form/waitlist-enabled-checkbox/waitlist-enabled-checkbox'
import type { OpportunityFormWaitlistEnabledCheckboxProps } from './components/opportunity-form/waitlist-enabled-checkbox/waitlist-enabled-checkbox.types'
import { OpportunityFormTimeLogsAreRewardsEligibleCheckbox } from './components/opportunity-form/time-logs-are-rewards-eligible-checkbox/opportunity-form-time-logs-are-rewards-eligible-checkbox'
import type { OpportunityFormTimeLogsAreRewardsEligibleCheckboxProps } from './components/opportunity-form/time-logs-are-rewards-eligible-checkbox/opportunity-form-time-logs-are-rewards-eligible-checkbox.types'
import { OpportunityFormAutomaticTimeTrackingConfirmationModal } from './components/opportunity-form/automatic-time-tracking-confirmation-modal/opportunity-form-automatic-time-tracking-confirmation-modal'
import type { OpportunityFormAutomaticTimeTrackingConfirmationModalProps } from './components/opportunity-form/automatic-time-tracking-confirmation-modal/opportunity-form-automatic-time-tracking-confirmation-modal.types'

export * from './components/attendees-list/attendees-list'
export * from './components/attendees-list/attendees-list.types'
export * from './components/select-option-card/select-option-card'
export * from './components/select-option-card/select-option-card.types'
export * from './components/survey-section/survey-section'
export * from './components/survey-section/survey-section.types'
export * from './components/opportunity-form/waiver-section/waiver-section'
export * from './components/opportunity-form/waiver-section/waiver-section.types'
export * from './components/survey-section/question-builder/question-builder'
export * from './components/survey-section/question-builder/question-builder.types'
export * from './components/survey-section/survey-response-form/survey-response-form'
export * from './components/survey-section/survey-response-form/survey-response-form.types'
export * from './components/survey-section/survey-response-field/survey-response-field'
export * from './components/survey-section/survey-response-field/survey-response-field.types'
export * from './components/survey-section/question-card/question-card'
export * from './components/survey-section/rating-input/rating-input'
export * from './dtos/opportunity.dto'
export * from './dtos/survey.dto'
export * from './dtos/waiver.dto'
export * from './utils/validation-utils'
export * from './utils/common-utils'
export * from './utils/get-opportunity-survey-id'
export * from './utils/find-opportunity-survey'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OpportunityForm {
  export type TypeStepProps = OpportunityFormTypeStepProps
  export const TypeStep = OpportunityFormTypeStep

  export type NameFieldProps = OpportunityFormNameFieldProps
  export const NameField = OpportunityFormNameField

  export type DescriptionFieldProps = OpportunityFormDescriptionFieldProps
  export const DescriptionField = OpportunityFormDescriptionField

  export type SingleOrSeriesStepProps = OpportunityFormSingleOrSeriesStepProps
  export const SingleOrSeriesStep = OpportunityFormSingleOrSeriesStep

  export type DateFieldsProps = OpportunityFormDateFieldsProps
  export const DateFields = OpportunityFormDateFields

  export type TimeTrackingCheckboxProps =
    OpportunityFormTimeTrackingCheckboxProps
  export const TimeTrackingCheckbox = OpportunityFormTimeTrackingCheckbox

  export type LocationSectionProps = OpportunityFormLocationSectionProps
  export const LocationSection = OpportunityFormLocationSection

  export type MaxAttendeesFieldProps = OpportunityFormMaxAttendeesFieldProps
  export const MaxAttendeesField = OpportunityFormMaxAttendeesField

  export type NotificationsEnabledCheckboxProps =
    OpportunityFormNotificationsEnabledCheckboxProps
  export const NotificationsEnabledCheckbox =
    OpportunityFormNotificationsEnabledCheckbox

  export type SkillsAndActivitiesSectionProps =
    OpportunityFormSkillsAndActivitiesSectionProps
  export const SkillsAndActivitiesSection =
    OpportunityFormSkillsAndActivitiesSection

  export type WaitlistEnabledCheckboxProps =
    OpportunityFormWaitlistEnabledCheckboxProps
  export const WaitlistEnabledCheckbox = OpportunityFormWaitlistEnabledCheckbox

  export type TimeLogsAreRewardsEligibleCheckboxProps =
    OpportunityFormTimeLogsAreRewardsEligibleCheckboxProps
  export const TimeLogsAreRewardsEligibleCheckbox =
    OpportunityFormTimeLogsAreRewardsEligibleCheckbox

  export type AutomaticTimeTrackingConfirmationModalProps =
    OpportunityFormAutomaticTimeTrackingConfirmationModalProps
  export const AutomaticTimeTrackingConfirmationModal =
    OpportunityFormAutomaticTimeTrackingConfirmationModal
}
